const STARTUPS_PER_PAGE = 10;

// /Google Analytics Constants definition
// /Client ID

export const CLIENT_ID = '279203342315-d8n5l9lafa06eb3ajom0libkj6rq9dig.apps.googleusercontent.com';

// /View ID

export const views = {
  query: {
    ids: 'ga:172254694',
  },
};

// /Get charts

export const accessFrom = {
  reportType: 'ga',
  query: {
    metrics: 'ga:sessions',
    dimensions: 'ga:country',
    'start-date': '30daysAgo',
    'end-date': 'yesterday',
    'max-results': 6,
    sort: '-ga:sessions',
  },
  chart: {
    type: 'GEO',
    options: {
      title: 'Top Countries by sessions in the last month',
    },
  },
};

export const totalActiveUsers = {
  reportType: 'ga',
  query: {
    metrics: 'ga:1dayUsers',
    dimensions: 'ga:date',
    'start-date': '30daysAgo',
    'end-date': 'yesterday',
    sort: '-ga:date',
  },
  chart: {
    type: 'LINE',
    options: {
      title: 'Last 30 days Active Users',
    },
  },
};

export const pathVisits = {
  reportType: 'ga',
  query: {
    metrics: 'ga:pageviews',
    dimensions: 'ga:pagePath',
    'start-date': '30daysAgo',
    'end-date': 'yesterday',
    'max-results': '10',
    sort: '-ga:pageviews',
  },
  chart: {
    type: 'TABLE',
    options: {
      title: 'Most visited pages in Ignis Gravitas',
    },
  },
};

// graph 2 config
export const last7days = {
  reportType: 'ga',
  query: {
    dimensions: 'ga:date',
    metrics: 'ga:pageviews',
    'start-date': '7daysAgo',
    'end-date': 'yesterday',
  },
  chart: {
    type: 'LINE',
  },
};


export { STARTUPS_PER_PAGE };
